import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const WorkforceProfileHub = Loadable(lazy(() => import('./WorkforceProfile/WorkforceProfileHub')));
const WorkforceProfileDetail = Loadable(lazy(() => import('./WorkforceProfile/WorkforceProfileDetail')));

const workforceProfileRoutes = [
    { path: '/employee/workforce', element: <WorkforceProfileHub />, auth: authRoles.guest },
    { path: '/employee/workforce/:id', element: <WorkforceProfileDetail />, auth: authRoles.guest },
];

export default workforceProfileRoutes;
